import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export const STUDIO_DEFAULT = {
  name: "Studio Nouvelle",
  tollFree: "800 960 201",
  phone: "089 214 5285",
  email: "pgiarletta@studionouvelle.it",
  site: "www.studionouvelle.it",
  siteUrl: "https://www.studionouvelle.it",
  hours: "Lun–Ven 09:00–13:00 · 15:30–19:00",
};

let cache = null;
const listeners = new Set();
const toCamel = (d) => ({ name: d.name, tollFree: d.toll_free, phone: d.phone, email: d.email, site: d.site, siteUrl: d.site_url, hours: d.hours });

export const loadStudio = () => axios.get(`${API}/public/studio`).then((r) => { cache = toCamel(r.data); listeners.forEach((l) => l(cache)); return cache; }).catch(() => cache || STUDIO_DEFAULT);

export function useStudio() {
  const [s, setS] = useState(cache || STUDIO_DEFAULT);
  useEffect(() => {
    listeners.add(setS);
    if (!cache) loadStudio();
    return () => listeners.delete(setS);
  }, []);
  return s;
}
